import React from "react";
import {PHOTO, SAFETY_FACTS, SAFETY_ROWS} from "../../data/siteData";
import {onLight, stagger, TINT} from "../../utils";
import Icon from "../common/Icon";
import ImageSlot from "../common/ImageSlot";
import SectionIntro from "../common/SectionIntro";

const SafetySection = () => (
    <>
        <SectionIntro
            id="safety"
            pill={{icon: 'shield', text: 'Safety', bg: 'rgba(228,0,60,0.12)', color: '#E4003C'}}
            title={<>Nobody hands you the gear, so <span style={{color: '#E4003C'}}>read this once</span></>}
            titleStyle={{maxWidth: '20ch'}}
            lead="The box is unstaffed, so these are the things worth knowing before you push off."
        />
        <section className="pb-container pb-section-body">
            <div className="pb-safety-grid">
                <div className="pb-card pb-safety-card">
                    <h2 className="pb-safety-heading">Before you push off</h2>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 14}}>
                        {SAFETY_ROWS.map((r, i) => (
                            <div key={r.text} className="pb-reveal pb-safety-row"
                                 style={{background: TINT[r.color], animationDelay: stagger(i, 70)}}>
                                <span style={{background: r.color}}><Icon name="check" size={13}/></span>
                                <p>{r.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div>
                    <div className="pb-safety-photo">
                        <ImageSlot src={PHOTO.safety} alt="Paddler wearing a buoyancy aid, close crop"/>
                    </div>
                    <div className="pb-emergency">
                        <p className="pb-emergency-pill"><Icon name="shield" size={15}/>In an emergency</p>
                        <p className="pb-emergency-call">Call 112</p>
                        <p className="pb-emergency-text">Then call the support number printed inside the lid. Stay
                            with the boat — it floats, and it is far easier to spot than a swimmer.</p>
                    </div>
                </div>
            </div>
            <div className="pb-facts">
                {SAFETY_FACTS.map((f, i) => (
                    <div key={f.title} className="pb-reveal pb-fact"
                         style={{borderTopColor: f.color, animationDelay: stagger(i)}}>
                        <span className="pb-fact-icon" style={{background: TINT[f.color], color: onLight(f.color)}}>
                            <Icon name={f.icon} size={22}/>
                        </span>
                        <h3>{f.title}</h3>
                        <p>{f.body}</p>
                    </div>
                ))}
            </div>
        </section>
    </>
);

export default SafetySection;
